import {Catalog, CatalogService, I18nCatalogId} from './catalog.service';

function extractLocaleI18n(serverCatalog: Catalog, localeId: string): {[key: string]: string} {
  const localeI18n = {};
  for (let [i18nKey, catEntry] of Object.entries(serverCatalog)) {
    localeI18n[i18nKey] = catEntry.translations[localeId];
  }
  return localeI18n;
}

const catalogService = new CatalogService();
const erroRegistoCatalog = catalogService.catalogs.get(I18nCatalogId.ERRO_REGISTO) ?? {};

export const ERRO_REGISTO = {
  en_US: {
    '*': {
      validations: extractLocaleI18n(erroRegistoCatalog, 'en-US')
    }
  },
  pt_PT: {
    '*': {
      validations: extractLocaleI18n(erroRegistoCatalog, 'pt-PT')
    }
  }
};
